var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSthpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 10.8337V4.16699C12.5007 2.78366 11.384 1.66699 10.0007 1.66699C8.61732 1.66699 7.50065 2.78366 7.50065 4.16699V10.8337C6.49232 11.592 5.83398 12.8087 5.83398 14.167C5.83398 16.467 7.70065 18.3337 10.0007 18.3337C12.3007 18.3337 14.1673 16.467 14.1673 14.167C14.1673 12.8087 13.509 11.592 12.5007 10.8337ZM9.16732 4.16699C9.16732 3.70866 9.54232 3.33366 10.0007 3.33366C10.459 3.33366 10.834 3.70866 10.834 4.16699H10.0007V5.00033H10.834V6.66699H10.0007V7.50033H10.834V9.16699H9.16732V4.16699Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSthpLogo);
export default __webpack_public_path__ + "static/media/SthpLogo.67e86f07c837e78a8171643776ebff6e.svg";
export { ForwardRef as ReactComponent };